import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useThemeStore, THEMES } from '@/stores/theme-store'
import { Check, Moon, Sun } from 'lucide-react'
import { cn } from '@/lib/utils'

export function ThemeToggle() {
  const { i18n } = useTranslation()
  const { mode, colorTheme, toggleMode, setColorTheme } = useThemeStore()
  const isThaiLike = ['th', 'lo', 'km'].includes(i18n.language)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          {mode === 'dark' ? (
            <Moon className="h-5 w-5" />
          ) : (
            <Sun className="h-5 w-5" />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          {isThaiLike ? 'ธีมและโหมด' : 'Theme & Mode'}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        {/* Light/Dark Mode */}
        <DropdownMenuItem
          onClick={toggleMode}
          className="flex items-center justify-between cursor-pointer"
        >
          <span className="flex items-center gap-2">
            {mode === 'dark' ? (
              <Moon className="h-4 w-4" />
            ) : (
              <Sun className="h-4 w-4" />
            )}
            <span>
              {mode === 'dark' 
                ? (isThaiLike ? 'โหมดมืด' : 'Dark Mode') 
                : (isThaiLike ? 'โหมดสว่าง' : 'Light Mode')
              }
            </span>
          </span>
          <span className="text-xs text-muted-foreground">
            {isThaiLike ? 'กดเพื่อสลับ' : 'Click to toggle'}
          </span>
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs text-muted-foreground">
          {isThaiLike ? 'ธีมสี' : 'Color Theme'}
        </DropdownMenuLabel>
        
        {/* Theme Options */}
        {Object.entries(THEMES).map(([key, theme]) => (
          <DropdownMenuItem
            key={key}
            onClick={() => setColorTheme(key as keyof typeof THEMES)}
            className={cn(
              "flex items-center justify-between cursor-pointer",
              colorTheme === key && "bg-accent"
            )}
          >
            <div className="flex items-center gap-3">
              <span className="text-lg">{theme.icon}</span>
              <div>
                <p className="font-medium text-sm">
                  {isThaiLike ? theme.labelTh : theme.label}
                </p>
                <p className="text-xs text-muted-foreground">
                  {isThaiLike ? theme.descriptionTh : theme.description}
                </p>
              </div>
            </div>
            {colorTheme === key && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
